import { useQuery } from '@tanstack/react-query';
import useUser from '../global/useUser';
import { LoadedUser } from '../../interfaces';
import { getJoinRequests } from '../../services/joinRequests';
import { isTeamManager } from '../../utils/global/helper';

function useGetJoinRequests() {
  const { user } = useUser<LoadedUser>();
  const businessId = user?.business?.id;

  return useQuery({
    queryKey: ['join-requests', businessId],
    queryFn: () => getJoinRequests(businessId!),
    enabled: !!businessId && !!user && isTeamManager(user),
  });
}

export default useGetJoinRequests;
